export const iconFontAwesomeScienceFireFlameSimple = (
	<i className="fa-solid fa-fire-flame-simple"></i>
);
